export const UPDATE_RESTAURANT_SEARCH_KEY = "UPDATE_RESTAURANT_SEARCH_KEY";
export const UPDATE_RESTAURANT_LIST = "UPDATE_RESTAURANT_LIST";
export const UPDATE_CUSINES = "UPDATE_CUSINES";
export const UPDATE_RESTAURANT_INFO = "UPDATE_RESTAURANT_INFO";

